
const Offline=() => {

    return (
        <div>Oops no internet</div>
    )
}
export default Offline;